import React, { useState } from 'react';
import { Card, CardBody, Col, Container, Row } from 'reactstrap';
import { MarkJecno, MARKJENCOEMAIL } from '../../Constant';
import NavTab from './NavTab';
import Img from '../../assets/images/user/user.png';
import { Image, P, H6, Breadcrumbs } from '../../AbstractElements';
import BookmarksTabs from './BookmarksTabs';

const BookmarksContain = () => {
  const [IsOpen, setIsOpen] = useState(false);
  const OnHandelClick = () => {
    setIsOpen(!IsOpen);
  };
  return (
    <Container fluid={true}>
      <Breadcrumbs pageTitle='Bookmarks' parent='Apps' title='Bookmarks' />
      <div className='email-wrap bookmark-wrap'>
        <Row>
          <Col xl='3' className='xl-30 box-col-30'>
            <div className='md-sidebar email-sidebar'>
              <a className='btn btn-primary md-sidebar-toggle' href='#javascript' onClick={OnHandelClick}>
                Bookmark Filter
              </a>
              <div className={`md-sidebar-aside email-left-aside ${IsOpen ? 'open' : ''}`}>
                <Card>
                  <CardBody>
                    <div className='email-app-sidebar left-bookmark'>
                      <div className='d-flex'>
                        <div className='d-flex-size-email'>
                          <Image className='me-3 rounded-circle' src={Img} alt='' />
                        </div>
                        <div className='flex-grow-1'>
                          <H6 className='f-w-600 text-uppercase'>{MarkJecno}</H6>
                          <P>{MARKJENCOEMAIL}</P>
                        </div>
                      </div>
                      <NavTab />
                    </div>
                  </CardBody>
                </Card>
              </div>
            </div>
          </Col>
          <Col xl='9' md='12' className='xl-70 box-col-70'>
            <div className='email-right-aside bookmark-tabcontent'>
              <Card className='email-body radius-left'>
                <div className='ps-0'>
                  <BookmarksTabs />
                </div>
              </Card>
            </div>
          </Col>
        </Row>
      </div>
    </Container>
  );
};
export default BookmarksContain;
